import { Component, Input, OnInit } from "@angular/core";
import { AngularSvgIconModule } from "angular-svg-icon";

@Component({
  selector: "app-asterisk-with-number",
  templateUrl: "./asterisk-with-number.component.html",
  styleUrls: ["./asterisk-with-number.component.scss"],
  standalone: true,
  imports: [AngularSvgIconModule],
})
export class AsteriskWithNumberComponent implements OnInit {
  @Input() number: number | string = "";
  @Input() numberColor: string = "var(--wild-hare)";
  @Input() numberSize: number = 0.9375;
  @Input() asteriskColor: string = "beautyberry";
  @Input() asteriskSize: number = 1.875;
  @Input() fontWeight: string = "700";
  /** Overrides the badge glyph. Defaults to the asterisk used everywhere today. */
  @Input() iconSrc: string = "assets/icons/icon-asterisk.svg";

  ngOnInit(): void {}
}
